export default "__VITE_ASSET__nHtwhj8X__"